import React from 'react'
import { formatDateNoTime } from '../../AutoTrafficFineNotificationLookup/utils/formatDate'
import vehicleCar from '../../../assets/images/vehicle_car.png'
import vehicleElectricMotorbike from '../../../assets/images/vehicle_electric_motorbike.png'
import vehicleMotorbike from '../../../assets/images/vehicle_motorbike.png'

const VehicleTypeIconMap = {
  1: vehicleCar,
  30: vehicleMotorbike,
  40: vehicleElectricMotorbike
}

export default function NotifyPackageBanner({ plate, autoRenewUntil, productName, allowRenew, vehicleType }) {
  const expireText = formatDateNoTime(autoRenewUntil)
  const isAutoRenew = Number(allowRenew) === 1
  const iconSrc = VehicleTypeIconMap?.[Number(vehicleType)] || vehicleCar
  const lineText = isAutoRenew ? `Gia hạn tự động vào ${expireText || '—'}` : `Hết hạn vào ${expireText || '—'}`

  return (
    <div className="traffic-fine-package-banner-wrap">
      <div className="traffic-fine-package-banner">
        <div className="traffic-fine-package-banner-inner">
          <div className="traffic-fine-package-banner-top">
            <div className="traffic-fine-package-banner-title">{productName || 'Gói thông báo'}</div>
            <img
              src={iconSrc}
              alt=""
              className="traffic-fine-package-banner-vehicle"
              onError={(e) => {
                e.currentTarget.style.display = 'none'
              }}
            />
          </div>

          <div className="traffic-fine-package-banner-bottom">
            <div className="traffic-fine-package-banner-subtitle">{lineText}</div>
            <div className="traffic-fine-package-banner-plate">
              <span>{plate || '—'}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
